import React, { useEffect, FC } from 'react';
import MerchantCouponCalendar from '../../../../molecules/merchant/calendar/MerchantCouponCalendar';
import { SpCouponCalendar } from '../SpCouponCalendar';
import {
  useViewDevice,
  ViewDevice,
} from '../../../../contexts/ViewDeviceContext';
import { useShallowEqualSelector } from '../../../../hooks/redux';
import { init } from '../../../../redux/actions/merchants/services';
import { ReduxState } from '../../../../redux/reducers';
import { useAppDispatch } from '../../../../redux';

type Props = {
  merchantPublicId: string;
  merchantTimeZone: string;
  couponPublicId: string;
};
export const CouponCalendarOrganism: FC<Props> = ({
  merchantPublicId,
  merchantTimeZone,
  couponPublicId,
}) => {
  const viewDevice = useViewDevice();
  const reduxState = useShallowEqualSelector(
    (state: ReduxState) => state.merchantsServices,
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(init(merchantPublicId, merchantTimeZone));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { services, baseDate, fetchedUntil, viewStyle, meta } = reduxState;

  return (
    <>
      {viewDevice.currentViewDevice === ViewDevice.WebPc && (
        <MerchantCouponCalendar
          merchantPublicId={merchantPublicId}
          merchantTimeZone={merchantTimeZone}
          couponPublicId={couponPublicId}
        />
      )}
      {viewDevice.currentViewDevice === ViewDevice.WebSp && (
        <SpCouponCalendar
          merchantPublicId={merchantPublicId}
          merchantTimeZone={merchantTimeZone}
          couponPublicId={couponPublicId}
          fetchedUntil={fetchedUntil}
          viewStyle={viewStyle}
          services={services}
          baseDate={baseDate}
          meta={meta}
        />
      )}
    </>
  );
};
